import cf from './cf';
import i1zv1 from './i1zv1_20211024';

export default class i1zv1b extends i1zv1 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
//    this.class = 'i1zv1b';
    global.t = this;
    this.d_viewDefs = {
      name: 'エントリー',
      class: 'i1zv1b',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
//    this.i1zrt11i = 20; // 登録区分
//    this.class = 'i1zv1b'; // 登録区分
  }

}
